<mat-toolbar class="topbar">
  <!-- --------------------------------------------------------------- -->
  <!-- Desktop Menu -->
  <!-- @if(showToggle) {
  <button
    mat-icon-button
    (click)="toggleCollapsed.emit()"
    class="d-flex justify-content-center"
  >
    <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
  </button>
  } -->

  <!-- Mobile Menu -->
  @if(!showToggle && showToggleButton) {
  <button mat-icon-button (click)="toggleMobileNav.emit()" class="d-flex justify-content-center">
    <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
  </button>
  }
  <div class="d-none d-sm-flex">
    <!-- --------------------------------------------------------------- -->
    <!--  Links -->
    <!-- --------------------------------------------------------------- -->
      <a *ngFor="let item of menuItems"
        mat-button
        [routerLink]="[item.link]"
        routerLinkActive="active"
        #foractive="routerLinkActive"
        [color]="foractive.isActive ? 'primary' : ''">
        {{ item.title | translate }}
      </a>
    <button mat-button [matMenuTriggerFor]="appsmenu" aria-label="Reports">
      <div class="d-flex align-items-center">
        {{ 'LABEL.REPORT' | translate }} <i-tabler name="chevron-down" class="icon-16 m-l-4"></i-tabler>
      </div>
    </button>
    <mat-menu #appsmenu="matMenu" class="cardWithShadow">
      <div class="p-10 p-b-0">
        @for(report of reportsMenus; track report.id) {
        <div class="text-hover-primary cursor-pointer">
          <a mat-menu-item
            [routerLink]="report.link"
            class="hover-text text-decoration-none f-s-14 d-block p-y-10 p-x-8"
            [class.active-report-menu-item]="isReportMenuActive(report.link)"
          >
            {{ report.title }}
          </a>
        </div>
        }
      </div>
    </mat-menu>
  </div>

  <span class="flex-1-auto"></span>

  <!-- Mobile Menu -->
  <!-- <button mat-icon-button (click)="toggleMobileFilterNav.emit()" class="d-flex d-lg-none justify-content-center">
    <i-tabler name="grid-dots" class="icon-20 d-flex"></i-tabler>
  </button> -->

  <!-- --------------------------------------------------------------- -->
  <!-- profile Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <button mat-icon-button [matMenuTriggerFor]="profilemenu" aria-label="Notifications">
    <img *ngIf="userdetail.avatar; else defaultAvatar" [src]="userdetail.avatar"
      class="rounded-circle object-cover icon-35 profile-dd b-1" width="35"
      fallbackImage="assets/images/profile/user-1.jpg" />

    <ng-template #defaultAvatar>
      <img src="/assets/images/profile/user-1.jpg" class="rounded-circle object-cover icon-35 profile-dd b-1"
        width="35" />
    </ng-template>

  </button>
  <mat-menu #profilemenu="matMenu" class="topbar-dd cardWithShadow">
    <ng-scrollbar class="position-relative" style="height: 400px">
      <div class="p-x-20 p-y-16">
        <h6 class="f-s-16 f-w-600 m-0 mat-subtitle-1">{{ 'USERDETAILS' | translate }}</h6>

        <div class="d-flex align-items-center p-b-24 b-b-1 m-t-16">
          @if (userdetail.avatar){
          <img src={{userdetail.avatar}} class="rounded-circle b-1" width="95"
            fallbackImage="assets/images/profile/user-1.jpg" />
          }@else {
          <img src='/assets/images/profile/user-1.jpg' class="rounded-circle b-1" width="95" />
          }

          <div class="m-l-16">
            <h6 class="f-s-14 f-w-600 m-0 mat-subtitle-1">{{userdetail.firstName||''}} {{userdetail.lastName||''}}
            </h6>
            <span class="f-s-14 d-block m-b-4">{{userdetail.roleName||''}}</span>
            <span class="d-flex align-items-center">
              <i-tabler name="mail" class="icon-15 m-r-4"></i-tabler>
              {{userdetail.email||''}}
            </span>
          </div>
        </div>
      </div>
      <div class="p-x-32">
        @for(profile of profiledd; track profile.title) {

        <a class="p-y-16 text-decoration-none d-block text-hover-primary" [routerLink]="[profile.link]">
          <div class="d-flex align-items-center">
            <button mat-mini-fab class="text-primary bg-light-primary shadow-none rounded">
              <img [src]="profile.img" width="20" />
            </button>

            <div class="m-l-16">
              <h5 class="f-s-14 f-w-600 m-0 textprimary mat-subtitle-1 hover-text">
                {{ profile.title | translate }}
              </h5>
              <span class="mat-body-1">{{ profile.subtitle | translate }}</span>
            </div>
          </div>
        </a>
        }

      </div>

      <div class="p-y-12 p-x-32">
        <a (click)="logout()" mat-stroked-button color="primary" class="w-100">{{ 'BUTTON.BTN_LOGOUT' | translate }}</a>
      </div>
    </ng-scrollbar>
  </mat-menu>
</mat-toolbar>
<!-- <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar> -->